import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { FormationId, FormationLight } from '@wwf/sdk';
import { FormationCover } from './FormationCover';

export const FormationListContent = ({
    openEditDrawer,
}: {
    openEditDrawer: (id: FormationId) => void;
}) => {
    const { data, error, isPending } = useListContext<FormationLight>();

    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) return null;
    if (!data?.length) {
        return (
            <Stack p={2}>
                <Typography>No formations found</Typography>
            </Stack>
        );
    }

    return (
        <List dense>
            {data.map(formation => (
                <RecordContextProvider key={formation.id} value={formation}>
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() =>
                                formation.id && openEditDrawer(formation.id)
                            }
                            alignItems="center"
                        >
                            <ListItemAvatar>
                                <FormationCover />
                            </ListItemAvatar>
                            <ListItemText
                                primary={formation.name}
                                secondary={formation.description}
                            />
                        </ListItemButton>
                    </ListItem>
                </RecordContextProvider>
            ))}
        </List>
    );
};
